<script>
  import Heading from './Heading.svelte';
  import { Button, Accordion, AccordionItem, Span } from 'flowbite-svelte';
  import { EditOutline } from 'flowbite-svelte-icons';
  import { createQuery } from '@tanstack/svelte-query';
  import { client } from './lib/client';
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';
  import CuratedByCarousel from './CuratedByCarousel.svelte';

  const isProd =
    window.location.hostname.includes('curatedby.us') ||
    window.location.hostname.includes('creators.posttap.com');

  export let successToast = () => {};

  async function listPagesQuery() {
    const pages = await client.get('/api/curated/page/list');
    return pages.data;
  }

  $: pagesQuery = createQuery({
    queryKey: ['temp-query-key'],
    queryFn: listPagesQuery,
  });

  const handleCreateAnother = () => {
    navigate('/curated-by/create');
  };

  const handleCopyUrl = (url) => {
    navigator.clipboard.writeText(url);
    successToast('Link Copied!');
  };

  const curatedHostname = () => {
    return isProd ? 'curatedby.us' : 'curatedby-staging.us';
  };
</script>

<div>
  {#if $pagesQuery.isSuccess}
    <Heading class="mb-4">
      {$_('curatedby.dashboard.title', {
        default: 'CuratedBy',
      })}
    </Heading>
    <CuratedByCarousel />
    <div class="success-view">
      <Accordion class="w-full rounded-xl !border-none bg-white">
        {#each $pagesQuery.data?.objects ?? [] as page, index}
          {@const [handle, pagePath] = page.path.split('/')}
          <AccordionItem
            class={index === ($pagesQuery.data?.objects?.length ?? 0) - 1
              ? 'rounded-b-xl'
              : ''}
          >
            <div
              slot="header"
              class="flex w-full items-center justify-between pr-4"
            >
              <Span class="text-left font-semibold">
                <span class="block md:inline">{curatedHostname()}/</span
                >{`${handle}/${pagePath}`}
              </Span>
              <div class="flex gap-2">
                <button
                  class="text-gray-500 hover:text-black"
                  on:click={(e) => {
                    // required so the event doesn't propogate to the accordion
                    e.stopPropagation();
                    handleCopyUrl(
                      `https://${curatedHostname()}/${handle}/${pagePath}`,
                    );
                  }}
                >
                  <svg
                    width="19"
                    height="23"
                    viewBox="0 0 19 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.83331 11.4998V19.1665C1.83331 19.6748 2.03525 20.1623 2.39469 20.5218C2.75414 20.8812 3.24165 21.0832 3.74998 21.0832H15.25C15.7583 21.0832 16.2458 20.8812 16.6053 20.5218C16.9647 20.1623 17.1666 19.6748 17.1666 19.1665V11.4998M13.3333 5.74984L9.49998 1.9165M9.49998 1.9165L5.66665 5.74984M9.49998 1.9165V14.3748"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  on:click={() => {
                    navigate(`/curated-by/edit?page=${page.id}`);
                  }}
                >
                  <EditOutline class="h-5 w-5 text-gray-500 hover:text-black" />
                </button>
              </div>
            </div>
            <div class="space-y-4">
              <table class="w-full">
                <tbody class="divide-y">
                  <tr class="border-t">
                    <td class="py-3 text-sm text-gray-600">
                      {$_('curatedby.dashboard.handle', {
                        default: 'Handle',
                      })}
                    </td>
                    <td class="py-3 text-gray-900">{handle}</td>
                  </tr>
                  <tr>
                    <td class="py-3 text-sm text-gray-600">
                      {$_('curatedby.dashboard.socialHandle', {
                        default: 'Social Handle',
                      })}
                    </td>
                    <td class="py-3 text-gray-900"
                      >{page.configuration.socialHandle}</td
                    >
                  </tr>
                  <tr>
                    <td class="py-3 text-sm text-gray-600">
                      {$_('curatedby.dashboard.bioLine1', {
                        default: 'Bio Line 1',
                      })}
                    </td>
                    <td class="py-3 text-gray-900"
                      >{page.configuration.bioLine1}</td
                    >
                  </tr>
                  <tr>
                    <td class="py-3 text-sm text-gray-600">
                      {$_('curatedby.dashboard.bioLine2', {
                        default: 'Bio Line 2',
                      })}
                    </td>
                    <td class="py-3 text-gray-900"
                      >{page.configuration.bioLine2}</td
                    >
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionItem>
        {/each}
      </Accordion>
      <Button
        class="mt-6 flex w-full items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 p-6 font-medium text-gray-900 hover:bg-gray-50"
        on:click={handleCreateAnother}
        disabled={$pagesQuery?.data?.objects.length >= 3}
      >
        {#if ($pagesQuery?.data?.objects ?? []).length > 0}
          {$_('curatedby.dashboard.createAnotherPageLink', {
            default: '+ Create Another CuratedBy Page',
          })}
        {:else}
          {$_('curatedby.dashboard.createPageLink', {
            default: '+ Create CuratedBy Page',
          })}
        {/if}
      </Button>
    </div>
  {/if}
</div>
